<template>
   <!-- -->
  <div id="app"   @click='isDo'>
    <router-view/>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'App',
  data() {
    return {
        utilpath0: '',
        lastTime: null, //最后一次点击的时间
        currentTime: null, //当前点击的时间
        timeOut: 30*60*10000 //设置超时时间： 10分钟
        // timeOut:   6000 //设置超时时间： 10分钟
    };
  },
   beforeDestory() {
    sessionStorage.clear();
    window.localStorage.clear();
  },
  methods: {
      isDo() {
          this.$http.post(this.utilpath0 + '/checklogin',  { emulateJSON: true}).then((res) => {
                if(res.data.status == '9'){
                  this.$router.push({path:'/ui/login',query:{msg:9}});
                }else if(res.data.status == '-9'){
                  this.$router.push({path:'/ui/login',query:{msg:2}});
                }
              }, (err) => {
                console.log(JSON.stringify(err));
              });
      }
  },
  mounted(){
    this.utilpath0 = axios.defaults.baseURL;
  },
  created(){

      this.lastTime = new Date().getTime(); //网页第一次打开时，记录当前时间
  }


}

</script>
<style>

.fade-enter-active, .fade-leave-active {
  transition: opacity .9s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
:root {
 --color: #56B8AA;
 --coloron: #1CAF9D;
 --fontcolor: #fff;
 --choosecolor: #0097a5;
}
.load-more-normal {
    text-align: center;
    height: 60px;
    line-height: 60px;
  }

  .load-more-hide {
    height: 0;
  }
/*login-css start*/
  .logtop {
   text-align: center;
   margin-bottom: 20px;
  }
  .logimg {
   width: 36%;
   height: auto;
  }
  .login-container a {
   color: #41B09C;
   position: relative;
  }
  .loginform {
   position: absolute;
   top: 15%;
   left: 50%;
   -webkit-box-shadow: 0 0 10px rgba(86,184,170,.6);
    box-shadow: 0 0 14px rgba(86,184,170,.4);
    border-radius: 3px;
   -webkit-transform: translateX(-50%);
   -ms-transform: translate(-50%);
   transform: translatex(-50%);
  }
/*login-css end*/

/*product-css start */
#contain{
    position: fixed;
    top: 130px;
    left: 218px;
    right: 0;
    bottom: 0;
    overflow: auto;
}
  .productbox .product-list{
    position:relative;
  }
  .productbox .product-list ul{
    font-size:12px;
  }
  .productbox .product-list ul li{
    float: left;
    width: 15%;
    min-width: 11rem;
    height: 220px;
    /*background: #dbdcad;*/
    background: #fff;
    border-radius: 4px;
    margin: 0 .8rem 1.2rem 0;
    overflow:hidden;
    -webkit-transition: all .3s ease-out;
      transition: all .3s ease-out;
  }
  .productbox .product-list ul li:hover {
      border-color: var(--color);
      -webkit-transform: translateY(-5px);
      -ms-transform: translateY(-5px);
    transform: translateY(-5px);
    -webkit-box-shadow: 0 0 10px rgba(86,184,170,.6);
    box-shadow: 0 0 10px rgba(86,184,170,.6);
      -webkit-transition: all .3s ease-out;
      transition: all .3s ease-out;
  }
  /*.productbox .product-list ul li:nth-child(6n){
    margin-right:0;
  }*/
  .productbox .product-list.mar6 ul li:nth-child(6n) {
    margin-right: 0;
  }
  .productbox .product-list.mar5 ul li:nth-child(5n) {
    margin-right: 0;
  }
   .productbox .product-list.mar4 ul li:nth-child(4n) {
    margin-right: 0;
  }
  .productbox .product-list.mar3 ul li:nth-child(3n) {
    margin-right: 0;
  }
   .productbox .product-list.mar2 ul li:nth-child(2n) {
    margin-right: 0;
  }
  .productbox .product-list ul li .pro img{
    width:100%;
    height:135px;
  }
  .productbox .product-list ul li .promain{
      /*padding:0 16px;*/
      margin-top: 5px;
  }
  .productbox .product-list ul li .promain .promsg{
    margin-bottom:6px
  }
  .productbox .product-list ul li .promain .promsgbot{
    margin-bottom:12px;
    height:24px;
    line-height:24px;
    margin: 0 10px;
  }
    .model.cartModel .content {
     width: 400px;
    }
    .butt{
      position:relative;
      margin:20px 34px;
    }
    .butt but{
      width:200px;
      margin-bottom:20px;
    }
    .numbox{
          text-align: center;
    }
    .num{
          margin: 10px auto;
    }
    div.logo img{
      opacity:0.4;
      filter:alpha(opacity=40);
    }
/*roduct-css end*/

/*receives-css start*/
    #top{
      position: fixed;
      top: 130px;
      left: 218px;
      padding: 10px 0 0 20px;
      border-radius: 3px;
      /*-webkit-box-shadow: rgba(86,184,170,.2) 0 1px 2px 0px;
      box-shadow:rgba(86,184,170,.2) 0 1px 2px 0px;
      border-bottom:1px solid rgba(206,206,206,.8);*/
    }
    .tablebox table{
        /*-moz-box-shadow:0 0 4px rgba(86,184,170,.3);
        -webkit-box-shadow:0 0 4px rgba(86,184,170,.3);
        box-shadow:0 0 4px rgba(86,184,170,.3);*/
    }
    .model .content .tablebox table {
     text-align: center;
     margin: 0 auto;
     width: 732px;
    }
    .order-list-table table {
     /*width: 100%;*/
     margin-bottom: 20px;
     background-color: #fff;
    }
    tr.bordercolor{
      border-bottom: 1px solid #56B8AA;
    }
/*receives-css end*/

/*pandian-css start*/
  div.show {
   display: none
  }
  .n1:first-child {
   /*margin-top: 20px;*/
  }
  .n1 .huol span, .huor span {
   display: inline-block;
   width: 88px;
  }
  .butbox {
   margin: 25px 0 2px 0;
  }
  .h {
   height: 50px;
  }
  .h .text{
    display:inline-block;
    height:36px;
    line-height:36px;
  }
  .h .el-input__inner{
    height: 36px !important;
    line-height: 36px !important;
  }
  .my .el-input__inner{
    height: 36px !important;
    line-height: 36px !important;
  }
  .prinbox {
   margin: 20px 0;
  }
  .tabletitleinput.el-input{
    width: 8rem !important;
  }
  .tabletitleinput.el-input--prefix .el-input__inner{
        height: 2rem !important;
  }
  .tablebox .tabletitleinput{
    width: 8rem;
    margin:6px 6px
  }
  .tablebox .tabletitleinput.el-date-editor.el-input, .tablebox .tabletitleinput.el-date-editor.el-input__inner{
    width: 8rem !important;
  }
  .tablebox .tabletitleinput .el-input__inner{
    border: 1px solid #DCDFE6 !important;
      height: 2rem;
  }
/*pandian-css end*/

/*tijiao-css start*/
  .huol, .huor {
   float: left;
   margin: 0px 26px 20px 0px;
  }
  .butlbox {
   margin-bottom: 20px;
  }
  .butlbox span {
   height: 2rem;
   line-height: 2rem;
   margin-right: 2rem;
  }
  .tijiao span {
   line-height: 0;
   margin: 0;
  }
  table {
   background: #fff;
  }

  .item-all-check {
   position: relative;
   margin: 0 16px;
  }
  .item-all-check2 {
   position: relative;
  }
  .item-all-check a {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate3d(-50%, -50%, 0)
  }
  .list-item-check {
   position: relative;
  }
  .list-item-check a {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate3d(-50%, -50%, 0)
  }
  .item-check-btn .icon-ok {
   position: relative;
   display: none;
   width: 100%;
   height: 100%;
   fill: #fff;
   -webkit-transform: scale(0.6);
   -ms-transform: scale(0.6);
   transform: scale(0.6);
   vertical-align: top;
  }
  .item-check-btn.check .icon-ok {
   display: inline-block;
  }
  .item-check-btn {
   display: inline-block;
   width: 1rem;
   height: 1rem;
   background: #fff;
   border: 1px solid #999;
   border-radius: 50%;
   text-align: center;
   vertical-align: middle;
   cursor: pointer;
  }
  .gou{
    text-align:center;
    color:#fff;
    font-weight: 300;
  }
  .item-check-btn.checked {
   border-color: var(--color);
    display: inline-block;
    border: 1px solid #56B8AA;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 1rem;
    height: 1rem;
    background-color: var(--color);
    -webkit-transition: all .3s ease-out;
    transition: all .3s ease-out;
    z-index: 1;
  }
  .item-check-btn{
    width: 1rem;
    height: 1rem;
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    display: inline-block;
    line-height: 1rem;
    position: relative;
    vertical-align: middle;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 1;
    -webkit-transition: all .3s ease-out;
    transition: all .3s ease-out;
  }
  .item-check-btn:hover{
    border-color:var(--color);
    -webkit-transition: all .3s ease-out;
    transition: all .3s ease-out;
  }
  .searchtime .el-input--prefix .el-input__inner {
    padding-left: 1rem;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 12rem !important;;
}
.searchtime:hover.iconshow .el-input__prefix{
  display:none;
}
.searchtime2 .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 168px !important;
}
.searchtime.searchtime2 .el-input__prefix {
    left: 8.9rem !important;
}
form.my .pan .el-input {
    width: 168px !important;
}
/*tijiao-css end*/

/*yitijiao-css start*/
    .returnmsg {
     color: var(--color);
    }
    .model .content {
     margin: 3rem auto;
     width: 1140px;
     padding-bottom: 20px;
     border-radius: 4px;
     background-color: #fff;
    }
    .roleModel.model .content {
        margin: 3rem auto !important;
    }
    .updateuser.model .content{
      width: 510px !important;
    }
    .model.querenmodel .content {
        width: 400px !important;
    }
    .model .content .title {
     position: relative;
     padding: 14px 20px 30px;
    }
    .model .content .title .fl {
     float: left;
     font-size: 16px;
     color: var(--color);
    }
    .model .content .title .fr {
     float: right;
    }
    .model .content .tablebox table th {
     height: 32px;
     /*width: 104px;*/
     background-color: var(--color);
     font-weight: normal;
     color: #fff;
    }

    .model .content .tablebox table td {
     /*width: 104px;*/
     height: 32px;
     padding: 0;
    }
    .model .content .tablebox table td input {
     width: 100%;
     margin: auto 0;
     text-align: center;
     background: none;
     outline: none;
     border: 0px;
    }
    .model .content .tablebox table td:last-child {
     width: 16%;
    }
    /*.top {
      position: fixed;
      top: 130px;
      left: 218px;
      z-index:204;
      width:100%;
      background-color:#eff0f4;
    } */
    .top .demo-form-inline{
     position: relative;
    }
    .top span.title {
     display: inline-block;
     float: left;
     margin-top: 6px;
     margin-right: 10px;
    }
    .allckeck {
     color: #fff;
    }
    .ckecked {
    color: #fff;
    }
    .order-list-table table {
     /*width: 100%;*/

     margin-bottom: 20px;
     background-color: #fff;
    }
    .order-list-table table.downtablelist {
      /*width:1200px;*/
      table-layout:fixed;
    }
    .but.fr, .but2 {
     margin: 20px 0px 30px 664px;
    }
    .but2 {
     margin-top: 4px;
    }
    .but:hover {
     background-color: var(--coloron);
     border-color: var(--coloron);
    }
    .order-list-table th {
     text-align: center;
     height: 2.8rem;
     background-color: var(--color);
     color: #fff;
    }
    .order-list-table th {
     border: 1px solid #56B8AA;
    }
    .order-list-table th span.toptitle {
     font-weight: normal;
     margin-right: 20px;
    }
    .order-list-table table th.allckeck {
     border: 1px solid var(--color);
     background: #fff;
    }
    .order-list-table table tr td.lastbut {
     padding: 0 10px;
    }
    .order-list-table table th.thbox {
     position: relative;
    }
    .order-list-table td img.titleimg {
     width: 110px;
     height: 110px;
    }
    .tuihuo span{
      margin-right: 30px;
    }
/*yitijiao-css end*/

/*diaobo-css start*/
  .mobut.fr{
    margin: 20px 8px 0 0;
  }
  .inputtext{
    margin:0 auto;
    width: 53rem;
  }
  .inputtext div.tinp.el-form-item{
    margin-right:19px !important;
  }
  .inputtext .labelp .el-form-item__label{
    margin-right:.8rem;
  }
  .jiantouxia.jiantoushang{、
   webkit-transform: rotateZ(180deg)  translate(50%, 50%);
    transform: rotateZ(180deg)  translate(50%, 50%);
 }

.jiantouxia{
    transition: transform .3s, -webkit-transform .3s;
    transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -webkit-transform:rotateZ(0deg);
    -o-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
    cursor: pointer;
}
.icon-jiantou_yemian_xiangshang{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -webkit-transform:translate(-50%, -50%);
    -o-transform:translate(-50%, -50%);
    -moz-transform:translate(-50%, -50%);
 }


    .tabletitle{
      margin:0 10px;
      font-weight:400;
    }
    .n1 .huol, .huor {
     float: left;
     /*margin: 20px 26px 0px 0px;*/
     height: 2rem;
     width: 412px;
    }

    .n1 .huol span, .huor span {
     display: inline-block;
     width: 100px;
    }
    .butbox {
     margin-top: 4px;
    }
    .tablebox {
     margin-top: 20px;
    }
    .tablebox.kucun {
      margin-top: 0px;
    }
/*diaobo-css end*/
/*huowei2-css start*/
.trbg.bgcolor{
  background-color:#B2FFF5;
}
/*huowei2-css end*/
/*diaochudan-css end*/
  .h {
   height: 50px;
  }
/*diaochudan-css end*/
/*creatuser-css start*/
  .cbox{
    margin: 0px auto;
    width: 65%;
    min-width:330px;
    /*height: 31.25rem;*/
    border-radius: 2px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff;
    -moz-box-shadow:0 0 4px rgba(86,184,170,.3);
    -webkit-box-shadow:0 0 4px rgba(86,184,170,.3);
    box-shadow:0 0 4px rgba(86,184,170,.3);
  }
/*creatuser-css end*/
/*setting-css start*/
  .h {
   margin: 10px 0;
  }
  .h:first-child {
   margin-top: 0px;
  }
  .h .fl {
   display: inline-block;
   width: 110px;
  }
  .h .el-input {
    width: 72%;
    margin-left: 10px;
  }
  .dis{
    margin-left:0px;
  }
  .h .el-input.is-disabled .el-input__inner {
   background-color: #f5f7fa;
   border-color: #e4e7ed;
   color: #868686;
  }
  .but {
   color: #fff;
   background: #56B8AA;
   border-color: #56B8AA;
   width: 300px;
   margin: 5px 0 15px -38px
  }

  .user .el-form-item__content{
    margin-left:120px !important
  }
/*setting-css end*/
.clearfix:after{
    content: "020";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
 }
.clearfix {
    zoom:1;
    overflow: hidden;
}
.app {
 position: relative;
}
.tinp2 .el-form-item__content{
	margin:0 20px 0px 108px !important;
}
.tinp2 .el-input {
    width: 260px !important;
}
.el-form-item {
    margin-bottom: 8px !important;
}
.nav-icon {
 vertical-align: middle !important;
 margin-right: 6px !important;
 width: 24px !important;
 text-align: center !important;
 font-size: 17px !important;
 color: var(--color) !important;
}
.el-submenu__title i {
 color:var(--color) !important;
}
.el-menu-item i{
  color:var(--color) !important;
}
.el-submenu__icon-arrow {
 color: #909399!important;
 font-size: 13px;
}
.el-menu-item.is-active a.nav-zi {
 color: var(--color) !important;
}
.el-menu {
 border-right: 0 !important;
}
.el-submenu__title {
 background-color: #F9F9F9;
 border-bottom: solid 1px #F2F2F2 !important;
}
.el-menu {
 background-color: #FcFcFc
}
.el-menu li.el-menu-item {
 border-bottom: solid 1px #F2F2F2 !important;
}
.el-menu-item:hover, .el-menu-item:focus {
 outline: none;
 background-color: #fff !important;
}
.el-submenu__title:hover {
 outline: none;
 background-color: #fff !important;
}
div.single {
 height: 56px;
 line-height: 56px;
 font-size: 14px;
 color: #303133;
 padding: 0 20px;
 list-style: none;
 background-color: #F9F9F9;
 border-bottom: solid 1px #F2F2F2;
}
.single:hover {
 background-color: #fff;
}
div.isActive {
 background-color: #fff;
 color:#56b8aa !important;
}
.isActive {
 background-color: #fff;
 color:#56b8aa !important;
}
ul.close{
    visibility:visible;
    transition: height .3s;
}
ul.isClose{
  /*display:none !important;*/
  height:0px !important;
  visibility:hidden;
  -webkit-transition: height.3s ;
  -moz-transition:height .3s ;
  -ms-transition:height .3s ;
  -o-transition:height .3s ;
  transition: height .3s ;
}
.jiantouxia{
    transition: transform .3s, -webkit-transform .3s;
    transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -webkit-transform:rotateZ(0deg);
    -o-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    cursor: pointer;
}
.el-submenu__icon-arrow{
   transition: transform .3s, -webkit-transform .3s;
    transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -webkit-transform:rotateZ(0deg);
    -o-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
}
div.jianfangxiang .el-submenu__icon-arrow{
   transition: transform .3s, -webkit-transform .3s;
    transform: rotateZ(180deg);
    -ms-transform: rotateZ(180deg);
    -webkit-transform:rotateZ(180deg);
    -o-transform: rotateZ(180deg);
    -moz-transform: rotateZ(180deg);
}
i.jian {
 position: absolute;
 top: 22px;
 right: 20px;
 font-size: 13px;
 color: #909399
}
.clear {
 overflow: hidden;
 *zoom: 1;
}
.posbox {
 position: relative;
}
.asideposi {
 position: fixed;
 top: 0px;
 padding-top: 60px;
 height: 100vh;
 z-index: 1000;
}
.asideposi ul{
  width:200px;
}
.el-header {
 position: fixed !important;
 top: 0;
 z-index: 2042 !important;
}
.mainpos {
 position: absolute;
 top: 117px;
 left: 200px;
}
.breadpos {
 position: fixed;
 top: 60px;
 z-index: 500;
 height: 56px;
 line-height: 56px;
 width: 100%;
 padding-left: 220px;
 box-sizing: border-box;
 -moz-box-shadow:0 0 4px rgba(86,184,170,.3);
 -webkit-box-shadow:0 0 4px rgba(86,184,170,.3);
 box-shadow:0 0 4px rgba(86,184,170,.3);
}
.headerbut {
 margin-right: 10px;
}
.headerbut .text {
 margin-left: 10px;
 color: #fff;
}
.headerbut .text, .headerbut i {
 color: #fff;
}
.el-form-item__label {
 text-align: left !important;
 padding: 0 0px 0 0 !important;
 /*line-height: 2rem !important;*/
}
.el-form-item_content {
 width: 308px !important;
 margin-left: 114px !important;
}
div.rmsg .el-form-item__error {
 /*top: 10px !important;
 left: 337px !important;*/
 width: 130px;
}
.rmsg .el-input__inner{
    min-height: 36px !important;
    line-height: 36px !important;
}
.juese.rmsg .el-input__inner{
    height: 60px !important;
}
div.gongying .el-form-item__error {
    width: 276px;
}
.el-form-item__error {
 left: 20px !important;
}
.el-form--inline .el-form-item {
 margin:0 0px 20px 20px !important;
}
div.mingxibut.el-form--inline .el-form-item{
margin: 0px 0px 0px 20px !important;
}
.n1 .el-input__inner, .huor .el-input__inner {
 height: 2rem !important;
 width: 308px !important;
}
div.tinp.el-form-item {
 margin: 0 .6rem 0.9rem 0 !important;
}
div.tinp.tuitip.beizhuinp.el-form-item {
 width:909px !important;
}
div.tinp.el-form-item:nth-child(4n) {
 margin-right: 0 !important;
}
div.tablebox .el-form-item {
 margin: 0 !important;
}
div.tablebox .tdwidth .el-form-item {
 height:40px !important;
}

div.n1 div.tinp.el-form-item {
    margin: 0 1rem .8rem 0 !important;
}
div.tinp .el-form-item__label, div.tinp .el-form-item__label {
    width: auto !important;
    /*margin-right: .3rem;*/
}
div.tinp.tuitip .el-form-item__label, div.tinp.tuitip .el-form-item__label {
    width: 112px !important;
}
div.tinp .el-form-item__content, div.tinp .el-form-item__content .el-input__inner {
    line-height: 2rem !important;
    /*width: 12rem !important;*/
    min-width:129px !important;
    height: 2rem !important;
}
div.tinp.beizhu .el-form-item__content, div.tinp.beizhu .el-form-item__content .el-input__inner {
    width:461px !important;
}
div.tinp.proType .el-form-item__content, div.tinp.proType .el-form-item__content .el-input__inner {
    width: 416px !important;
    min-width: 416px !important;
}
div.tinp2 .el-form-item__content, div.tinp .el-form-item__content .el-input__inner {
    line-height: 2rem !important;
    height: 2rem !important;
}
div.tinp2 .el-form-item__label {
    padding-left: 20px !important;
}
div.n1 div.tinp .el-form-item__content, div.n1 div.tinp .el-form-item__content .el-input__inner {
    width: 18rem !important;
}
div.n1 div.tip_b .el-form-item__content, div.n1 div.tip_b .el-form-item__content .el-input__inner, div.n1 div.tip_b .el-form-item__content .el-input {
 width: 735px !important;
}
.n1 .el-input, .n1 .el-input {
     line-height: 2rem !important;
     height: 2rem !important;
     width: 18rem !important;
}
.huol .el-input, .huor .el-input, .huor .el-input .el-input__inner, .huol .el-input .el-input__inner, .myselect .el-input__inner {
 line-height: 2rem !important;
 height: 2rem !important;
 /*width: 260px !important;*/
}
.el-input__icon {
 line-height: 2rem !important;
}
.el-table thead {
 color: #fff !important;
}
.el-table {
 background-color: rgba(239, 240, 244, 0) !important;
}
div.shou .el-table {
 background-color: #fff !important;
 padding: 0 10px;
}
.el-table tr {
 height: 38px !important;
}
.el-table td {
 padding: 0px !important;
}
.el-table .cell {
 padding: 0px !important;
}
div.line {
 width: 100%;
 height: 1px;
 background-color: #cccccc;
 margin-bottom: 20px;
}
.fl {
 float: left;
}
.fr {
 float: right;
}
input.tabinp {
 width: 100%;
 font-size: 13px;
 text-align: center;
 background: none;
 outline: none;
 border: 0px;
}
.el-table--enable-row-hover .el-table__body tr:hover>td {
 background-color: #fff !important;
}
.el-table--enable-row-hover .el-table__body tr.current-row>td {
 background-color: #fff !important;
}
.tablebox .el-input__inner {
 width: 100% !important;
 font-size: 13px !important;
 text-align: center !important;
 background: none !important;
 outline: none !important;
 border: 0px !important;
 padding: 0 !important;
}
.tablebox .xiugai .el-input__inner {
     text-align: left !important;
}
.el-table__empty-block {
 height: auto;
}
.el-table th, .el-table {
 text-align: center !important;
}
.clear {
 overflow: hidden;
 *zoom: 1;
}
.el-button.del {
 padding: 8px 20px;
 font-size: 13px;
}
div.el-form-item.userlog .el-form-item__content {
 margin: 0 30px !important;
}
div.el-form-item.userlog {
 margin-bottom: 22px !important;
}
div.el-form-item.sublog .el-form-item__content {
 margin-left: 55px !important;
}
div.el-form-item.sublog .el-button {
 width: 252px !important;
 margin-left: 0px;
}
.el-form-item.is-success .el-input__validateIcon {
 display: none !important;
}
.el-input__suffix-inner .el-input__suffix-inner i.el-input__icon.el-icon-circle-close.el-input__clear {
 width: 0 !important;
}
.tuihuo .el-form-item__content{
	margin:0 20px!important;
}
.tuititle .el-form-item__content {
    margin:0px!important;
}
.tuititle span {
    margin-right:20px!important;
}
.tuiproname .el-form-item__content{
   margin-left:0px!important;
}
form.my .el-input {
 margin-left: 0px !important;
}
.el-table--group::after, .el-table--border::after, .el-table::before {
 background: rgba(255, 255, 255, 0) !important;
}
.el-table--group, .el-table--border {
 border: 0px solid #ebeef5 !important;
}
.el-table--group, .el-table--border tr {
 border: 1px solid #ebeef5 !important;
}
div.kucun .el-table__header {
 width: 100% !important;
}
.el-table__header {
 width: 100% !important;
}
.el-menu-item.is-active {
 background: #fff !important;
}
.navzi .el-submenu .el-menu-item {
 min-width: 183px !important;
}
div.single {
 position: relative;
}
.myone .el-input__suffix {
    left: 225px !important;
    top: 2px !important;
}
 div.tinp2 .el-form-item__error {
    left: 276px !important;
    top: 10px !important;
}
.el-message{
	z-index:2042 !important;
}
.user .el-form-item {
    margin-bottom: 20px !important;
}
.user .passlabel .el-form-item__label{
  width:120px !important;
}
.mini .el-input-number__decrease {
    width: 24px !important;
}
.el-input-number--mini {
    width: 100px !important;
}
.goodsList .el-row .el-col-5 {
    width: 183px !important;
}
.goodsList .el-row .el-col-offset-2 {
    margin-left: 13px !important;
}
.model {
     position: fixed;
     z-index: 2042;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     background-color: rgba(0, 0, 0, .5);
}
.messageModel{}
.el-input {
    font-size: .8rem !important;
  }
  .el-button--small {
    padding: 8px 10px !important;
    margin-top: 1px;
    height: 2rem;
  }
  .order-list-table{
    /*width:66rem;*/
  }
  .searchtime .el-input__prefix{
    left:10.1rem;
  }
  .searchtime.searchmonth .el-input__prefix {
    left: 7.8rem;
}
.searchmonth .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 154px;
}
  .fenye .el-pagination .el-select .el-input{
      position: relative;
  }
  .fenye .el-input__suffix-inner{
      position: absolute;
      left: -29px;
  }
  .el-picker-panel.el-date-picker.el-popper{
    z-index:2042 !important;
  }
  .el-select-dropdown.el-popper{
    z-index:2042 !important;
  min-width: 300px !important;
  }
  .v-modal {
    z-index:2042 !important;
  }
  .el-message-box__wrapper{
    z-index:2043 !important;
  }
  div.juetitle{
    font-size:14px;
    margin-bottom:14px;
    color:var(--color);
  }
  /*AddRole start*/
  .el-tree-node .el-tree-node__content{
   /* padding-left: 22px !important; */
  }
  /*新增货位*/
  .model.selectmodel .content {
     width: 20rem !important;
  }
  .selectinput .el-form--inline .el-form-item__content{
    width:100%;
  }
  .tdwidth{
    border: 1px solid #56B8AA;
    width:6%;
  }
  .tdwidth:nth-child(2){
    width:10%;
  }
  table tr.first.noimg th, table tr.first.noimg td{
    text-align:left;
    padding-left:15px;
  }
  table tr.first.noimg, table tr.first.noimg{
     height: 50px;
  }
  .el-tree-node__expand-icon.is-leaf {
    border-left: 1px dashed #afafaf;
  }
  .tablebox table.bigtablelist{
    min-width:1126px;
  }
  table.downtablelist{
    min-width:1160px;
    max-width:1160px;
  }
  .tablebox table.bigtablelist td{
    border: 1px solid #56B8AA;
  }
  .tablebox table.bigtablelist td.noborder{
    border: 0px solid #56B8AA;
  }
  .el-message-box {
    width: 800px !important;
    height: 400px !important;
  }
  .el-button--primary.mendianbut {
    border-color: #ffffff;
}

.mendianbut.el-select .el-input .el-select__caret{
  color:#fff !important;
}
.mendianbut.el-select {
  width: 220px !important;
}
.mendianbut .el-input--suffix .el-input__inner{
    background-color: #31a594;
    background-image: none;
    border-radius: 49px;
    border: 1px solid #31a594;
    height: 30px;
    line-height: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #ffffff;
}
/*.tabproinp el-input{
    width: 250px !important;
    height: 36px !important;
    line-height: 36px !important;
    margin:0 20px 10px 0 !important;
}
.tabproinp el-input input.el-input__inner{
    height: 36px !important;
    line-height: 36px !important;
}*/
div.tinp.beizhuinp .el-form-item__content, div.tinp.beizhuinp .el-form-item__content .el-input__inner{
  width:436px !important;
  min-width:436px !important;
}
div.tinp.tuitip.beizhuinp .el-form-item__content, div.tinp.tuitip.beizhuinp .el-form-item__content .el-input__inner{
  width:691px !important;
  min-width:390px !important;
}
div.mingxibut.el-form--inline .el-form-item{
    margin: 0px 0px 0px 20px !important;
}
.el-loading-mask {
    background-color: rgba(255, 255, 255, 0.4) !important;
}
.el-loading-mask.is-fullscreen {
    z-index: 942 !important;
}
/*.el-breadcrumb{
  line-height:14px !important;
}*/
table.pamdiantable tr.notTrue{
  color:#F56C6C !important;
}
div#Loginbackground{
  background:url(../static/img/longinbg.jpg) no-repeat;
}
.modelmsg2{
    position: fixed;
    z-index: 2042;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.modelmsg2.querenmodel .content {
    width: 400px !important;
}
.modelmsg2.querenmodel .content.isquerencontent {
    width: 660px !important;
    height: 370px !important;
}
.modelmsg2 .content {
    margin: 3rem auto;
    width: 1140px;
    padding-bottom: 20px;
    border-radius: 4px;
    background-color: #fff;
    border: 8px solid #45ad9e;
    border-radius: 2px;
    -moz-box-shadow:3 3 4px rgba(86,184,170,.3);
    -webkit-box-shadow:3 3 4px rgba(86,184,170,.3);
    box-shadow:3 3 4px rgba(86,184,170,.3);
}
.modelmsg2 .content .title {
    position: relative;
    padding: 14px 20px 30px;
}
.modelbgcolor{
  position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    z-index: 2042;
    background-color: rgba(0, 0, 0, .5);
}
.tdtitle{
    color: #119481;
    font-weight: 1000;
}
.numbox .el-textarea__inner{
  min-height: 272px !important;
  height: 272px !important;
}
.el-textarea__inner{
      border: 0px solid #dcdfe6 !important;
}
.trancss { }
  .trancssv-leave { }
  .trancssv-leave-active { transition: all 3s;}
  .trancssv-leave-to {opacity: 0;}
  .trancssv-enter { }
  .trancssv-enter-active { transition: all 3s;}
  .trancssv-enter-to {}
</style>



// WEBPACK FOOTER //
// src/App.vue